import { render } from "./PriceItems.vue?vue&type=template&id=1c4f778a&scoped=true&lang=pug"
import script from "./PriceItems.vue?vue&type=script&lang=js"
export * from "./PriceItems.vue?vue&type=script&lang=js"

import "./PriceItems.vue?vue&type=style&index=0&id=1c4f778a&lang=scss&scoped=true"

import exportComponent from "/Applications/DEV/kevin/GIT/monafoto.ee/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4f778a"]])

export default __exports__